module.exports = __webpack_public_path__ + "img/Solutions-TaxAssist.cba0d1f5.jpeg";